module.exports = __webpack_public_path__ + "img/1+1-Tafel_keine.b842c6ea.png";